import { useLayoutEffect } from 'react';

const CLASS_VIDEO_INTERFACE = 'video-interface';
const CLASS_GUI_INTERFACE = 'gui-interface';

export const useInterfaceClassName = (gui: boolean): void => {
    useLayoutEffect(() => {
        const { classList } = document.body;
        classList.add(gui ? CLASS_GUI_INTERFACE : CLASS_VIDEO_INTERFACE);

        return () => {
            classList.remove(gui ? CLASS_GUI_INTERFACE : CLASS_VIDEO_INTERFACE);
        };
    }, [gui]);
};
